module.exports = __webpack_public_path__ + "static/media/31.6dca8c00.png";